const DEFAULT_SCROLL_ID = 'content'

const hasQueryChanged = (to, from) => {
  const QUERY_PARAMS_TO_WATCH = ['category']
  return QUERY_PARAMS_TO_WATCH.reduce((acc, param) => {
    if (param === 'scrollId') {
      return false
    }
    const hasParamChanged = from.query[param] !== to.query[param]
    return acc || hasParamChanged
  }, false)
}

function scrollBehavior(to = {}, from = {}, savedPosition) {
  const defaultPosition = false
  const scrollTopPosition = { x: 0, y: 0 }
  let position = defaultPosition
  // triggerScroll is only fired when a new component is loaded
  if (to.path === from.path && hasQueryChanged(to, from)) {
    window.$nuxt.$nextTick(() => window.$nuxt.$emit('triggerScroll'))
  }
  return new Promise((resolve) => {
    window.$nuxt.$once('triggerScroll', () => {
      const scrollId = to && to.query.scrollId
      setTimeout(() => {
        const scrollElement = document.querySelector(
          `[data-scroll-id="${scrollId}"]`
        )
        if (scrollId) {
          if (!scrollElement) {
            position = -1
            const observer = new MutationObserver(() => {
              const awaitedScrollElement = document.querySelector(
                `[data-scroll-id="${scrollId}"]`
              )
              if (awaitedScrollElement) {
                observer.disconnect()
                position = { selector: `[data-scroll-id="${scrollId}"]` }
                resolve(position)
              }
            })
            observer.observe(document, {
              attributes: false,
              characterData: false,
              childList: true,
              subtree: true,
            })
            setTimeout(() => {
              if (observer) {
                observer.disconnect()
              }
            }, 1000 * 15)
          } else {
            position = { selector: `[data-scroll-id="${scrollId}"]` }
          }
        } else if (savedPosition) {
          position = { selector: `[data-scroll-id="${DEFAULT_SCROLL_ID}"]` }
        } else if (to.hash && document.querySelector(to.hash)) {
          position = { selector: to.hash }
        } else if (to.matched.length < 2) {
          position = scrollTopPosition
        } else if (
          to.matched.some(
            (child) => child.components.default.options.scrollToTop
          )
        ) {
          position = scrollTopPosition
        }

        if (scrollId && to.path !== from.path) {
          const router = window.$nuxt.$router
          const { path, query } = window.$nuxt.$route
          const { scrollId, ...oldQuery } = query
          router.replace({
            path,
            query: {
              ...oldQuery,
            },
          })
        }
        if (position !== -1) {
          resolve(position)
        }
      }, 10)
    })
  })
}

export default scrollBehavior
